<template>
  <div class="avue-top">
    <div class="top-bar__left">
      <div
          class="avue-breadcrumb"
          :class="[{ 'avue-breadcrumb--active': isCollapse }]"
          v-if="showCollapse"
      >
        <i class="el-icon-s-operation" @click="SetCollapse"></i>
      </div>
    </div>
    <div class="top-bar__title">
      <div class="top-bar__item top-bar__item--show" >
<!--        <topMenu ref="topMenu"></topMenu>-->
      </div>
    </div>
    <div class="top-bar__right">

      <el-dropdown class="top-index-icon-arrow-down">
            <span class="el-dropdown-link">
          <span
              style="color: #FFFFFF;">欢迎您   {{
              this.$store.state.user.userName ? this.$store.state.user.userName : ''
            }}</span>

          <i class="el-icon-arrow-down el-icon--right" style="color:#fff;"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="layout" divided>
           退出登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

  </div>
</template>
<script>
import {resetRouter} from '@/router/'
import {mapGetters, mapState} from "vuex";
import topMenu from "./top-menu";
import {baseURL1} from '@/util/http'
import {Post} from '@/util/http'
import axios from 'axios'
import Cookies from 'js-cookie'
import {getToken, setToken,} from "@/util/auth";
export default {
  components: {
    topMenu,
  },
  name: "toP",
  data() {
    return {};
  },

  filters: {},

  created() {},
  mounted() {

  },
  computed:{
    ...mapState({showCollapse: (state) => state.common.showCollapse,}),
    ...mapGetters(["isCollapse", "keyCollapse"])
  },

  methods: {
    // setCookie(name, value) {
    //   let Days = 30;
    //   let exp = new Date();
    //   exp.setTime(exp.getTime() - 1 );
    //   document.cookie = name + "=" + escape('JSESSIONID') + ";expires=" + exp.toGMTString();
    //   this.$store.commit('SET_TOKEN', '')
    //   window.location.href = 'https://siamtest.infore.com/siam/logout?service=http://localhost:8000/home/hello?url=http://localhost:8090/success'
    // },

    layout() {
      Post('/login/logout').then(res => {
        if (res.code === 200) {
          this.$store.commit('SET_TOKEN', '')
          this.$store.commit("SET_TAGLIST", []);
          setToken('')
          resetRouter()
          Cookies.remove('SIAMTGT');
          window.location.href = res.list
          // this.$router.push(`/login?redirect=${res.list}`)
        }
      })
      // this.$store.commit('SET_TOKEN', '')
      // this.$store.commit("SET_TAGLIST", []);
      // // window.location.href = `https://fawutest.infore.com/home/logout`
      // Post('/login/logout').then(res => {
      //   if (res.code === 200) {
      //
      //     resetRouter()
      //     Cookies.remove('SIAMTGT');
      //     this.$router.push(`/login?redirect=${res.list}`)
      //   }
      // })

    },
    SetCollapse() {
      this.$store.commit("SET_COLLAPSE");
    },
  },
};
</script>

<style lang="scss" scoped>
.avue-breadcrumb i{
   color: #fff;
}
</style>
